export const TILE_LAYERS = {
    OSM: 'OSM',
    HERE_NORMAL: 'here-normal',
    HERE_SATELLITE: 'here-satellite',
    HERE_HYBRID: 'here-hybrid',
};
